import { Button, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { MyOrdersDetailsActivityFeedComponent } from './MyOrdersDetailsActivityFeedComponent';
import IncomingTenantInfos from '../../serviceOrdering/components/common/IncomingTenantInfos';
import KeysInfos from '../../serviceOrdering/components/common/KeysInfos';
import OrderCommentsInfos from '../../serviceOrdering/components/common/OrderCommentsInfos';
import OrderPreviewInfos from '../../serviceOrdering/components/common/OrderPreviewInfos';
import PreviousTenantInfos from '../../serviceOrdering/components/common/PreviousTenantInfos';


const MyOrdersDetailsData = (props: any) => {
  return (
    <>
      {/*<OrdersDetailsDataGridToolbarComponent />*/}
      <div className="bg-container">
        <div className="border-bottom pb-2 d-sm-none">
          <Button
            variant="none"
            className={
              props.category === 'preview'
                ? 'w-100 lavender-box fw-bolder popoverTextPrimary'
                : 'w-100 fw-bolder popoverTextSecondary'
            }
            onClick={() => props.setCategory('preview')}
          >
            Aperçu de la commande
          </Button>
          <Button
            variant="none"
            className={
              props.category === 'tenant'
                ? 'w-100 lavender-box fw-bolder popoverTextPrimary'
                : 'w-100 fw-bolder popoverTextSecondary'
            }
            onClick={() => props.setCategory('tenant')}
          >
            L'occupant
          </Button>
          {(props.preview.category === 'entry' ||
            (props.preview.category === 'diagnostics' && props.preview.propertyState === 'vacant') ||
            (props.preview.category === 'visit' && props.preview.propertyState === 'vacant')) && (
            <Button
              variant="none"
              className={
                props.category === 'keys'
                  ? 'w-100 lavender-box fw-bolder popoverTextPrimary'
                  : 'w-100 fw-bolder popoverTextSecondary'
              }
              onClick={() => props.setCategory('keys')}
            >
              Les clés
            </Button>
          )}
          <Button
            variant="none"
            className={
              props.category === 'comments'
                ? 'w-100 lavender-box fw-bolder popoverTextPrimary'
                : 'w-100 fw-bolder popoverTextSecondary'
            }
            onClick={() => props.setCategory('comments')}
          >
            Les commentaires
          </Button>
        </div>

        <div className="d-flex flex-row gap-2 border-bottom pb-2 d-sm-block d-none">
          <Button
            variant="none"
            className={
              props.category === 'preview'
                ? 'lavender-box fw-bolder popoverTextPrimary'
                : 'fw-bolder popoverTextSecondary'
            }
            onClick={() => props.setCategory('preview')}
          >
            Aperçu de la commande
          </Button>
          <Button
            variant="none"
            className={
              props.category === 'tenant'
                ? 'lavender-box fw-bolder popoverTextPrimary'
                : 'fw-bolder popoverTextSecondary'
            }
            onClick={() => props.setCategory('tenant')}
          >
            L'occupant
          </Button>
          {(props.preview.category === 'entry' ||
            (props.preview.category === 'diagnostics' && props.preview.propertyState === 'vacant') ||
            (props.preview.category === 'visit' && props.preview.propertyState === 'vacant')) && (
            <Button
              variant="none"
              className={
                props.category === 'keys'
                  ? 'lavender-box fw-bolder popoverTextPrimary'
                  : 'fw-bolder popoverTextSecondary'
              }
              onClick={() => props.setCategory('keys')}
            >
              Les clés
            </Button>
          )}
          <Button
            variant="none"
            className={
              props.category === 'comments'
                ? 'lavender-box fw-bolder popoverTextPrimary'
                : 'fw-bolder popoverTextSecondary'
            }
            onClick={() => props.setCategory('comments')}
          >
            Les commentaires
          </Button>
        </div>

        <Row className="d-flex flex-row gap-0 flex-wrap">
          <Col xs={12} md={8}>
            {/*-----PREVIEW---------------------------------------------------------------------------------------------*/}
            {props.category === 'preview' && (
              <>
                <OrderPreviewInfos preview={props.preview} setPreview={props.setPreview} />
              </>
            )}

            {/*-----TENANT---------------------------------------------------------------------------------------------*/}
            {props.category === 'tenant' && (
              <div className="mt-3">
                {(props.preview.category !== 'diagnostics' ||
                  (props.preview.category === 'diagnostics' && props.preview.propertyState === 'busy')) && (
                  <>
                    {/* {props.preview.category ==="entry" && <TenantInfos showAndEdit={true} {...props.tenantProps} formerTenantInfosProps={props.formerTenantInfosProps}/>} */}
                    {/* {props.preview.category !== "entry" && <TenantInfos showAndEdit={true} {...props.tenantProps} />} */}
                  </>
                )}
                {props.previousTenantInfos.map((previousTenantInfos: any, index: number) => {
                  return (
                    <div key={index}>
                      <div className="mt-5 mb-4 border-bottom w-100"></div>
                      <PreviousTenantInfos
                        showAndEdit={true}
                        index={index}
                        previousTenantInfos={previousTenantInfos}
                        {...props.previousTenantProps}
                      />
                    </div>
                  );
                })}
                {props.incomingTenantInfos.map((incomingTenantInfos: any, index: number) => {
                  return (
                    <div key={index}>
                      <div className="mt-5 mb-4 border-bottom w-100"></div>
                      <IncomingTenantInfos
                        showAndEdit={true}
                        index={index}
                        incomingTenantInfos={incomingTenantInfos}
                        {...props.incomingTenantProps}
                      />
                    </div>
                  );
                })}
              </div>
            )}

            {/*-----KEYS---------------------------------------------------------------------------------------------*/}
            {props.category === 'keys' && (
              <div className="mt-3">
                <KeysInfos {...props.keys} showAndEdit={true} />
              </div>
            )}

            {/*-----COMMENTS---------------------------------------------------------------------------------------------*/}
            {props.category === 'comments' && (
              <div className="mt-3">
                <OrderCommentsInfos uid={props.preview.orderId} />
              </div>
            )}
          </Col>
          <Col xs={12} md={4}>
            <div className="mt-2 d-flex flex-column justify-content-between">
              <div className={'d-md-none'}>
                <MyOrdersDetailsActivityFeedComponent feed={props.activityFeedData} />
              </div>
              <div className={'border-start d-none d-md-block '}>
                <MyOrdersDetailsActivityFeedComponent feed={props.activityFeedData} />
              </div>
              <div className="d-flex flex-row justify-content-center flex-wrap">
                <div className="d-flex flex-column justify-content-center align-items-center text-middle ">
                  <p className="fw-bold popoverTextSecondary mb-0 pb-0 mt-4">Un problème ?</p>
                  <Link to="/support" target="_BLANK">
                    <Button className="mb-2 mb-lg-0 mx-lg-2 navbar-button btn-sm" variant="success" role="button">
                      Ouvrir un ticket
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default MyOrdersDetailsData;
